export const containsHtml = (str: string) => /<\/?[a-z][\s\S]*>/i.test(str);
